import { render, staticRenderFns } from "./PacksList.vue?vue&type=template&id=3726d105&scoped=true"
import script from "./PacksList.vue?vue&type=script&lang=js"
export * from "./PacksList.vue?vue&type=script&lang=js"
import style0 from "./PacksList.vue?vue&type=style&index=0&id=3726d105&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3726d105",
  null
  
)

export default component.exports